// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimplePopupdarkBG {
    background-color: rgba(0, 0, 0, 0.5);
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    overflow: hidden;
    position:fixed;
  }
  
  .SimplePopupcentered {
    position: fixed;
    top: 50%;
    left: 50%;
    overflow: hidden;
    transform: translate(-50%, -50%);
  }

  .SimplePopupmodal {
    width: 450px;
    
    display: flex;
    flex-direction: column;
    background: var(--simplepopup-background-color);
    color: var(--simplepopup-color);
    z-index: 51;
    border-radius: 8px;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
  }

  .SimpleModalmodalHeader {
    position: relative;
    height: 50px;
    width: 100%;
    background: var(--simplepopup-titlebackground-color);
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .SimpleModalheading {
    margin: 0;
    padding: 10px;

    color: var(--simplepopup-color);
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    
  }

  .SimpleModalcloseBtn {
    cursor: pointer;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 12px;
    border: none;
    font-size: 18px;
    color: var(--simplepopup-color);
    background: var(--simplepopup-background-color);
    transition: all 0.25s ease;
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.06);
    position: absolute;
    right: 0;
    top: 0;
    align-self: flex-end;
    margin-top: 2px;
    margin-right: 2px;
  }
  
  .SimpleModalcloseBtn:hover {
    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);
    transform: translate(-4px, 4px);
  }

  .SimpleModalcloseBtn:focus-visible {
    border: 1px solid white;
  }

  .SimplemodalContent-icon
{
    position:absolute;
    margin-top: 90px;
    margin-left: 10px;
    margin-right: 10px;
    width: 20%;  
    -webkit-user-select: none;  
            user-select: none;
    border:none;
}

.SimplemodalContent {
    position:relative;
    font-size: 15px;
    font-weight:300;
    color: var(--simplepopup-color);
    text-align: left;
    -webkit-user-select: none;
            user-select: none;
  }

.SimplemodalContent-text
{
  
  
  margin-top: 40px;
    width:70%;  
    margin-left: 25%;
    height: 50%;
    
}
.Simplemodal-div-buttons
{
  margin-bottom: 10px;
  padding-right: 10px;
  width: 450px;
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: right;
  margin-right: 10px;
           
}

.Simplemodal-button {
  

  border: solid;           /* assuming we don't want any borders */
  border-width: 2px;
  border-color: var(--simplepopup-button-border-color);
  color: var(--simplepopup-button-color);
  display: inline-block;  
  font-size: 14px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-left: 6px;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  
  text-shadow: 0 0 15px black, 0 0 10px black;  
  
  -webkit-user-select: none;  
  
          user-select: none;
  background:var(--simplepopup-button-background-color);
  border-radius: 10px; 
  cursor: pointer;        /* make the cursor like hovering over an <a> element */
  
}

.Simplemodal-button:hover,
.Simplemodal-button:focus-visible {
  background:var(--simplepopup-button-background-over-color);
}

.Simplemodal-button:active {
  
  transform: translate(-2px, 2px);
}
`, "",{"version":3,"sources":["webpack://./src/components/bases/popup/simplePopup.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,KAAK;IACL,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,YAAY;;IAEZ,aAAa;IACb,sBAAsB;IACtB,+CAA+C;IAC/C,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,oDAAoD;IACpD,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,aAAa;;IAEb,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,kBAAkB;;EAEpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,+CAA+C;IAC/C,0BAA0B;IAC1B,4CAA4C;IAC5C,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,oBAAoB;IACpB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4CAA4C;IAC5C,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;EACnB;;AAEF;;;;EAIE,gBAAgB;IACd,SAAS;IACT,gBAAgB;IAChB,WAAW;;AAEf;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;;AAEpB;;AAEA;;;EAGE,aAAa,YAAY,uCAAuC;EAChE,iBAAiB;EACjB,oDAAoD;EACpD,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qHAAqH;;EAErH,2CAA2C;;EAE3C,yBAAiB;;UAAjB,iBAAiB;EACjB,qDAAqD;EACrD,mBAAmB;EACnB,eAAe,SAAS,sDAAsD;;AAEhF;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;;EAEE,+BAA+B;AACjC","sourcesContent":[".SimplePopupdarkBG {\n    background-color: rgba(0, 0, 0, 0.5);\n    top:0;\n    left:0;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n    overflow: hidden;\n    position:fixed;\n  }\n  \n  .SimplePopupcentered {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    overflow: hidden;\n    transform: translate(-50%, -50%);\n  }\n\n  .SimplePopupmodal {\n    width: 450px;\n    \n    display: flex;\n    flex-direction: column;\n    background: var(--simplepopup-background-color);\n    color: var(--simplepopup-color);\n    z-index: 51;\n    border-radius: 8px;\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n  }\n\n  .SimpleModalmodalHeader {\n    position: relative;\n    height: 50px;\n    width: 100%;\n    background: var(--simplepopup-titlebackground-color);\n    overflow: hidden;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    user-select: none;\n  }\n  \n  .SimpleModalheading {\n    margin: 0;\n    padding: 10px;\n\n    color: var(--simplepopup-color);\n    font-weight: bold;\n    font-size: 20px;\n    text-align: center;\n    \n  }\n\n  .SimpleModalcloseBtn {\n    cursor: pointer;\n    font-weight: 500;\n    padding: 4px 8px;\n    border-radius: 12px;\n    border: none;\n    font-size: 18px;\n    color: var(--simplepopup-color);\n    background: var(--simplepopup-background-color);\n    transition: all 0.25s ease;\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.06);\n    position: absolute;\n    right: 0;\n    top: 0;\n    align-self: flex-end;\n    margin-top: 2px;\n    margin-right: 2px;\n  }\n  \n  .SimpleModalcloseBtn:hover {\n    box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.04);\n    transform: translate(-4px, 4px);\n  }\n\n  .SimpleModalcloseBtn:focus-visible {\n    border: 1px solid white;\n  }\n\n  .SimplemodalContent-icon\n{\n    position:absolute;\n    margin-top: 90px;\n    margin-left: 10px;\n    margin-right: 10px;\n    width: 20%;  \n    user-select: none;\n    border:none;\n}\n\n.SimplemodalContent {\n    position:relative;\n    font-size: 15px;\n    font-weight:300;\n    color: var(--simplepopup-color);\n    text-align: left;\n    user-select: none;\n  }\n\n.SimplemodalContent-text\n{\n  \n  \n  margin-top: 40px;\n    width:70%;  \n    margin-left: 25%;\n    height: 50%;\n    \n}\n.Simplemodal-div-buttons\n{\n  margin-bottom: 10px;\n  padding-right: 10px;\n  width: 450px;\n  display: flex;\n  flex-direction: row;\n  justify-content: right;\n  align-items: right;\n  margin-right: 10px;\n           \n}\n\n.Simplemodal-button {\n  \n\n  border: solid;           /* assuming we don't want any borders */\n  border-width: 2px;\n  border-color: var(--simplepopup-button-border-color);\n  color: var(--simplepopup-button-color);\n  display: inline-block;  \n  font-size: 14px;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  margin-left: 6px;\n  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;\n  \n  text-shadow: 0 0 15px black, 0 0 10px black;  \n  \n  user-select: none;\n  background:var(--simplepopup-button-background-color);\n  border-radius: 10px; \n  cursor: pointer;        /* make the cursor like hovering over an <a> element */\n  \n}\n\n.Simplemodal-button:hover,\n.Simplemodal-button:focus-visible {\n  background:var(--simplepopup-button-background-over-color);\n}\n\n.Simplemodal-button:active {\n  \n  transform: translate(-2px, 2px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
